// Pagos mensuales (viáticos y canastas): constantes y helpers compartidos
export const RECURRING_TYPES = [
  { value: 'viaticos', label: 'Viáticos', short: 'Viáticos' },
  { value: 'canasta_alimentos', label: 'Canasta de alimentos', short: 'Canasta' },
];
export const RECURRING_TYPE_VALUES = RECURRING_TYPES.map((t) => t.value);
export const isRecurringType = (t) => RECURRING_TYPE_VALUES.includes(t);
export const typeLabel = (t) => RECURRING_TYPES.find((x) => x.value === t)?.label || t;
export const typeShort = (t) => RECURRING_TYPES.find((x) => x.value === t)?.short || t;

// Fecha y mes LOCALES (toISOString usa UTC: de noche en Uruguay ya daría el día/mes siguiente)
export const localISODate = (d = new Date()) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
export const currentMonth = () => localISODate().slice(0, 7);

export const shiftMonth = (m, delta) => {
  const [y, mo] = m.split('-').map(Number);
  const d = new Date(y, mo - 1 + delta, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};

const MONTHS = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
export const monthLabel = (m) => (m ? `${MONTHS[Number(m.slice(5, 7)) - 1]} ${m.slice(0, 4)}` : '—');

export const money = (n) => `$${Number(n || 0).toLocaleString('es-UY', { maximumFractionDigits: 2 })}`;

export const fmtDate = (s) => {
  if (!s) return '';
  const [y, m, d] = String(s).slice(0, 10).split('-');
  return d && m && y ? `${d}/${m}/${y}` : s;
};

// Estado de una cuota (state calculado por el backend) -> etiqueta y color
export const STATE_STYLE = {
  paid: { label: 'Pagado', cls: 'bg-emerald-100 text-emerald-800 border-emerald-300' },
  pending: { label: 'Pendiente', cls: 'bg-amber-100 text-amber-800 border-amber-300' },
  overdue: { label: 'Atrasado', cls: 'bg-red-100 text-red-800 border-red-300' },
  cancelled: { label: 'Anulado', cls: 'bg-gray-100 text-gray-600 border-gray-300' },
};

// Distintivo "al día" de un jugador / plan
export const BADGE_STYLE = {
  al_dia: { label: 'Al día', cls: 'bg-emerald-100 text-emerald-800 border-emerald-300' },
  pendiente: { label: 'Pendiente', cls: 'bg-amber-100 text-amber-800 border-amber-300' },
  atrasado: { label: 'Atrasado', cls: 'bg-red-100 text-red-800 border-red-300' },
};
